import { ReactElement, useCallback } from 'react';

import { ModalCancelButton, ModalCloseButton } from '@dreryk/react-components';

import { AdamedExpertRegisterModalLoader } from './AdamedExpertRegisterModal.loader';
import { AdamedExpertRegisterForm } from './AdamedExpertRegisterForm';
import { AdamedExpertRegisterModalConfirmButton } from './AdamedExpertRegisterModalConfirmButton';

type AdamedExpertRegisterModalProps = {
   onClose: VoidFunction;
   authenticateOrRedirect: VoidFunction;
};

export const AdamedExpertRegisterModalContent = (props: AdamedExpertRegisterModalProps): ReactElement => {
   const handleSuccess = useCallback(() => {
      props.onClose();
      props.authenticateOrRedirect();
   }, [props]);
   return (
      <AdamedExpertRegisterModalLoader>
         {({ emailAddress, medicalLicenceNumber, consents }) => (
            <AdamedExpertRegisterForm
               emailAddress={emailAddress}
               medicalLicenceNumber={medicalLicenceNumber}
               consents={consents}
            >
               {({ handleSubmit, formState }) => (
                  <>
                     <AdamedExpertRegisterModalConfirmButton onSuccess={handleSuccess} handleSubmit={handleSubmit} />
                     <ModalCancelButton onClick={props.onClose} shouldConfirmExit={formState.isDirty} />
                     <ModalCloseButton onClick={props.onClose} shouldConfirmExit={formState.isDirty} />
                  </>
               )}
            </AdamedExpertRegisterForm>
         )}
      </AdamedExpertRegisterModalLoader>
   );
};
